/**
 * Paleta del catálogo para el color de las áreas (§3.5). Conjunto CERRADO de colores permitidos —
 * el selector muestra estos swatches, nunca un input type=color. Incluye los 6 colores ya sembrados
 * en incorp_areas (Sistemas #0ea5e9, RRHH #8b5cf6, Marketing #ec4899, Administración #ef4444,
 * Renting #f59e0b, Dirección #003c66) para que al editar un área existente su color salga marcado.
 *
 * El backend valida hex de 6 dígitos; esta lista es la restricción de UI (curada), no del esquema.
 */
export const PALETA_AREAS = [
  { valor: '#0ea5e9', nombre: 'Cielo' },
  { valor: '#3b82f6', nombre: 'Azul' },
  { valor: '#6366f1', nombre: 'Índigo' },
  { valor: '#8b5cf6', nombre: 'Violeta' },
  { valor: '#ec4899', nombre: 'Rosa' },
  { valor: '#ef4444', nombre: 'Rojo' },
  { valor: '#f97316', nombre: 'Naranja' },
  { valor: '#f59e0b', nombre: 'Ámbar' },
  { valor: '#10b981', nombre: 'Esmeralda' },
  { valor: '#14b8a6', nombre: 'Teal' },
  { valor: '#64748b', nombre: 'Pizarra' },
  { valor: '#003c66', nombre: 'Marino LAE' },
];

// Color por defecto para un área nueva (primer color de la paleta).
export const COLOR_AREA_DEFECTO = PALETA_AREAS[0].valor;
